import { render, staticRenderFns } from "./Customer-settings.vue?vue&type=template&id=4d7ee5e8"
import script from "./Customer-settings.vue?vue&type=script&lang=js"
export * from "./Customer-settings.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/account.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Customer-settings.vue?vue&type=style&index=1&id=4d7ee5e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports